import styled from 'styled-components';
import SelectRaw, { Props as SelectProps } from 'react-select';
import CreatableSelectRaw from 'react-select/creatable';
import AsyncSelect from 'react-select/async';

const CustomSelect = styled(SelectRaw)<SelectProps>`
    .customSelectEls__control {
        min-height: 50px !important;
        border: 0;
        border: 1px #bfbfbf solid;
        border-radius: 4px;
    }

    .customSelectEls__indicator-separator {
        display: none;
    }

    .customSelectEls__value-container {
        margin-top: 15px;
        padding-top: 0;
    }

    .customSelectEls__multi-value {
        margin: 0 2px;
    }

    .customSelectEls__menu {
        z-index: 99999;
    }
`;

const CustomAsyncSelect = styled(AsyncSelect)<any>`
    .customSelectEls__control {
        min-height: 50px !important;
        border: 0;
        border: 1px #bfbfbf solid;
        border-radius: 4px;
    }

    .customSelectEls__indicator-separator {
        display: none;
    }

    .customSelectEls__value-container {
        margin-top: 15px;
        padding-top: 0;
    }

    .customSelectEls__multi-value {
        margin: 0 2px;
    }
    
    .customSelectEls__menu {
        z-index: 99999;
    }
`;

const CustomCreatableSelect = styled(CreatableSelectRaw)<any>`
    .customSelectEls__control {
        min-height: 50px !important;
        border: 0;
        border: 1px #bfbfbf solid;
        border-radius: 4px;
    }

    .customSelectEls__indicator-separator {
        display: none;
    }

    .customSelectEls__value-container {
        margin-top: 15px;
        padding-top: 0;
    }

    .customSelectEls__multi-value {
        margin: 0 2px;
    }
    
    .customSelectEls__menu {
        z-index: 99999;
    }
`;

const StyledLabel = styled.label<{ active?: boolean }>`
    position: absolute;
    left: 10px;
    color: #999;
    transition: 200ms;
    font-size: 14px;
    top: 18px;
    pointer-events: none;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    right: 0;

    ${props => props.active && `
        top: 3px;
        left: 5px;
        color: #888;
        background: transparent;
        padding: 0 20px 0 4px;
        font-size: 12px;
    `}
`;

const Container = styled.div`
    position: relative;
    flex: 1;
`;

export { CustomSelect, Container, CustomCreatableSelect, StyledLabel, CustomAsyncSelect };
